<div class="CtepContent flex-row flex-top">
    <div class="CtepContent-container flex-col-12">
        <router-outlet></router-outlet>
    </div>
</div>
